import { Box, Button, Divider, makeStyles, TextField } from "@material-ui/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { updateOrderPod, updateShippingStatus } from "../../actions/editOrderActions";
import { customerPickupUpdate } from "../../actions/selfPickupActions";
import { getOpenSelfPickupSection, handleOpenSelfPickupManualDialog, handleOpenSelfPickupSection, showAlertSnackbar } from "../../reducers/uiSlice";
import { DataURIToBlob, getBranchById, getUserPreference } from "../../utilities/common";
import FullscreenLoading from "../Common/FullscreenLoading";
import ParcelScanSection from "./ParcelScanSection";
import PickupConfirmSection from "./PickupConfirmSection";
import PickupListSection from "./PickupListSection";
import { operationLog } from '../../actions/commonAction';

const useStyles = makeStyles((theme) => ({
    footer: {
        position: 'fixed',
        left: 0,
        bottom: 0,
        width: '100%',
        backgroundColor: '#5A5A5A',
        display: 'flex',
        height: 122,
        justifyContent: 'space-between'
    },
    leftButton: {
        position: 'fixed',
        bottom: 40,
        left: 48
    },
    rightButton: {
        position: 'fixed',
        bottom: 40,
        right: 48
    },
    button: {
        width: 'fit-content',
        padding: 8,
        fontSize: 15
    },
    sectionStyle: {
        marginBottom: 20
    },
    sectionTitleStyle: {
        color: '#FBFBFB',
        paddingBottom: 20,
        paddingLeft: 20,
        fontSize: '20px'
    },
    titleGroup: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#3a3a3a',
        paddingTop: 20
    },
    inputButtonGroup: {
        marginRight: 40,
        color: '#FF9D00',
        display: 'flex',
        alignItems: 'center'
    },
    manualInputButton: {
        marginLeft: 8
    }
}))


function PadIndex() {
    const classes = useStyles();
    const { t } = useTranslation('selfPickup');
    const dispatch = useDispatch();

    const userPref = getUserPreference();

    const openStage = useSelector(getOpenSelfPickupSection) || '0';
    const signature = useSelector(state => state.selfPickupReducer.signature);
    const scannedList = useSelector(state => state.selfPickupReducer.scannedOrders);

    const stageList = {
        '1': {
            text: t('scan')
        },
        '2': {
            text: t('customer_signature')
        },
        '3': {
            text: t('save')
        }
    }

    const sectionList = {
        '1': {
            text: t('pickup_list')
        },
        '2': {
            text: t('scan_parcels')
        },
        '3': {
            text: t('confirm_pickup')
        }
    }

    const [loading, setLoading] = useState(false);

    const handleCancel = () => {
        dispatch(handleOpenSelfPickupSection(Number(openStage) - 1));
    }

    const handleNextStep = () => {
        if (Number(openStage) === 3) {
            handleUpdate();
        } else {
            dispatch(handleOpenSelfPickupSection(Number(openStage) + 1));
        }
    }

    const handleUpdate = async () => {
        try {
            setLoading(true);
            await Promise.all(scannedList.map(async (order) => {

                const file = DataURIToBlob(signature);
                const fs = new File([file], 'image.jpg');
                let data = new FormData();
                data.append('order_ids', order.orders.order_id);
                data.append('driver_id', order.orders.shipping_staff_id);
                data.append('delivery_type', 2); // 2: self pickup
                data.append('delivery_result', 0); // 0: success
                data.append('pod_images[]', fs);

                await dispatch(customerPickupUpdate(data));
                await dispatch(operationLog(order.orders.order_id, userPref.username, 0, 1, 'CUSTOMER PICKUP', ''));
            }))
            await dispatch(showAlertSnackbar({ title: t('success'), message: t('pickup_success'), type: 'success' }))
            await dispatch(handleOpenSelfPickupSection(0));
        } catch (err) {
            dispatch(showAlertSnackbar({ title: t('failure'), message: t('update_error'), type: 'error' }))
        } finally {
            setLoading(false);
        }
    }

    const handleOpenManualDialog = () => {
        dispatch(handleOpenSelfPickupManualDialog(true));
    }

    return (
        <Box>
            <div className={classes.sectionStyle}>
                <div className={classes.titleGroup} style={{ position: 'relative' }}>
                    <div className={classes.sectionTitleStyle}>
                        {sectionList[openStage + ''].text}
                    </div>
                    {
                        openStage + '' === '2' &&
                        <div
                                className={classes.inputButtonGroup}
                                onClick={handleOpenManualDialog}
                                style={{ position: 'relative', zIndex: 1000 }}
                            >
                                <div>
                                    <img
                                        src={'/images/icons/finger.svg'}
                                        style={{ width: 24, height: 24 }}
                                    />
                                </div>
                                <div
                                    className={classes.manualInputButton}
                                >
                                    {t('manual_input')}
                                </div>
                        </div>
                    }
                </div>
                <Divider />
                {
                    openStage === 1 &&
                    <PickupListSection />
                }
                {
                    openStage === 2 &&
                    <ParcelScanSection />
                }
                {
                    openStage === 3 &&
                    <PickupConfirmSection />
                }
            </div>
            <div className={classes.footer}>
                <div className={classes.leftButton}>
                    <Button
                        color='primary'
                        className={classes.button}
                        onClick={handleCancel}
                    >
                        {t("common:cancel")}
                    </Button>
                </div>
                <div className={classes.rightButton}>
                    <Button
                        variant="contained"
                        className={classes.button}
                        color="primary"
                        onClick={handleNextStep}
                        disabled={openStage === 3 && !signature}
                    >
                        {stageList[openStage + '']?.text}
                    </Button>
                </div>
            </div>
            <FullscreenLoading open={loading} />
        </Box>
    )
}

export default PadIndex;